'use strict';

var _ = require('lodash');
var ConfigurationUserDefinedRefDataDirective = function ConfigurationUserDefinedRefDataDirective($rootScope, dtdModal) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/configuration-user-defined-ref-data.html'),
    controller: 'ConfigurationUserDefinedRefDataController',
    link: function link(scope, element) {
      function showDTDModal(event, data) {
        var type = dtdModal.getType(data.gridId);
        var modalElement = element.find('#' + _.kebabCase(type));
        modalElement.modal('show');
        scope.modalData = _.assign(data.entityData, {
          type: type
        });
      }
      function showStatusPopUp(event, data) {
        scope.$broadcast(scope.configurationStatusEventName + ':show', data);
      }
      var columnNameToEditHandlerMapping = {
        status: showStatusPopUp,
        setDTDLink: showDTDModal
      };
      scope.$on('urd:dtd-changed', function (event, type, rowId, value, modalData) {
        if (scope.canToggleStatus(type, modalData, value)) {
          scope.toggleStatusBasedOnDtds(rowId, value);
        }
        var setCellValueParams = {
          rowId: rowId,
          columnName: 'dtds',
          newValue: value,
          oldValue: modalData.dtds,
          gridId: dtdModal.getParentGridId(type),
          refreshOnly: true
        };
        $rootScope.$broadcast('grid:setCellValue', setCellValueParams);
      });
      scope.$on('grid:icon-click', function (event, data) {
        columnNameToEditHandlerMapping[data.fieldId].call(null, event, data);
      });
      scope.$on(scope.configurationStatusEventName + ':statusChanged', scope.changeStatusHandler);
    }
  };
};
ConfigurationUserDefinedRefDataDirective.$inject = ['$rootScope', 'DtdModalService'];
module.exports = ConfigurationUserDefinedRefDataDirective;